/**
 * Phase 0 route stub. Proves the route resolves and the theme applies.
 * Each one is replaced by its real surface in the phase named below.
 */
export function Placeholder({
  title,
  route,
  phase,
}: {
  title: string;
  route: string;
  phase: string;
}) {
  return (
    <main
      style={{
        minHeight: '100dvh',
        display: 'grid',
        placeContent: 'center',
        gap: 'var(--space-3)',
        padding: 'var(--space-8)',
        textAlign: 'center',
        background: 'var(--bg)',
        color: 'var(--text)',
      }}
    >
      <h1 style={{ margin: 0, fontSize: 'var(--text-xl)', fontWeight: 'var(--weight-bold)' }}>
        {title}
      </h1>
      <code style={{ color: 'var(--accent)', fontSize: 'var(--text-base)' }}>{route}</code>
      <p style={{ margin: 0, color: 'var(--muted)', fontSize: 'var(--text-sm)' }}>
        Built in {phase}
      </p>
    </main>
  );
}
